import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  appBarForm: {
    position: "relative",
    backgroundColor: "#222",
  },
  rootBusiness: {
    display: "flex",
    flexWrap: "wrap",
  },
  flexRow: {
    display: "flex",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    width: "100%",
    marginLeft: "5%",
    marginTop: "30px",
  },
  image: {
    width: "150px",
    marginLeft: "10px",
  },
  avatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  nameAvatar: {
    display: "flex",
    alignItems: "center",
    width: "35%",
  },
  data: {
    display: "flex",
    alignItems: "center",
    width: "65%",
    flexWrap: "wrap",
  },
  itemData: {
    width: "40%",
    maringTop: "30px",
  },
  divider: {
    width: "90%",
    marginTop: theme.spacing(5),
    marginLeft: "5%",
    paddingRight: "5%",
  },
  rolesAdmin: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    width: "100%",
    marginLeft: "5%",
    marginTop: theme.spacing(3),
  },
  selectRoles: {
    width: "300px",
    margin: "10px",
  },
  actionButton: {
    width: "45%",
    margin: "10px",
  },
  titleRolesAdmin: {
    width: "100%",
  },
  containerRolesAdmin: {
    width: "100%",
    display: "flex",
  },
  mainColumnRoleAdmin: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
  },
  transferListColumn: {
    width: "70%",
  },
}));

export default style;
